<template>
  <div>
    <article class="main-content">

      <OrderedComponents
        :data="content"
      />

    </article>
  </div>
</template>

<script setup>
import { productDynamic } from '~/graphql/pageQuery'
const route = useRoute()

const slug = route.params.slug

let content = null

const metaTitle = ref('')
const metaDescription = ref('')

useHead({
  title: metaTitle,
  meta: [ { name: 'description', content: metaDescription } ]
})

try {
  const { data } = await useAsyncQuery(productDynamic, { slug })
  content = data.value.productdynamics.data[0].attributes.page
  metaTitle.value = data.value.productdynamics.data[0].attributes.metatitle || 'Ростелеком Контакт-Центр'
  metaDescription.value = data.value.productdynamics.data[0].attributes.metadescription || ''
  if (!content.length) {
    throw createError({ statusCode: 404, message: 'Page not found' })
  }
} catch (error) {
  if (error.message.startsWith('Cannot read properties')) {
    throw createError({ statusCode: 404, message: 'Page not found', fatal: true })
  }
  throw createError({ statusCode: 500, message: 'Something went wrong',  fatal: true })
}

</script>
